import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { RoutableProps } from "preact-router";
import { ScanPackQR } from "../../../components/ScanPackQR";
import "./styles.scss";
import { SerialNumberType } from "../../../data/types";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand, useForceUpdate } from "../../../hooks";
import { addProductToDatabase, getProductsWithType, getProductTypeByName, getSerialNumberInfo, Product, ProductType } from "../../../api/product-api";
import { Alert } from "../../../components/Alert";

const elementLotRegex = /^([0-9A-Za-z-_+=]{1,20})$/m;
const elementLotRegexGs1 = /^.*01(\d{14}).*10([0-9A-Za-z-_+=]{1,20})/m;

export function LunaEMGEStopLOT(props: RoutableProps) {
    const [serialNumber, setSerialNumber] = useState("");
    const [isSerialNumberValid, setIsSerialNumberValid] = useState(false);
    const [serialNumbers, setSerialNumbers] = useState([] as { lot: string, serialNumber: string, valid: boolean, registered?: boolean }[]);
    const [typeInfo, setTypeInfo] = useState(null as { type: SerialNumberType, data: Product } | null);
    const [productType, setProductType] = useState(null as null | ProductType);
    const forceUpdate = useForceUpdate();
    const showSnackbar = useCommand<SnackbarShowCommand>();
    // const [existingEStopSerialNumbers, setExistingEStopSerialNumbers] = useState([] as Product[]);

    useEffect(() => {
        setIsSerialNumberValid(false);

        if (!serialNumber) {
            setTypeInfo(null);
            return;
        }

        if (!serialNumber.match(elementLotRegex)) {
            setTypeInfo(null);
            showSnackbar.run("Podany numer LOT jest w złym formacie", "error", "error", 3000);
            return;
        }

        setIsSerialNumberValid(true);
    }, [serialNumber]);

    useEffect(() => {
        getProductTypeByName("LE-EStop").then((v) => {
            setProductType(v);
        })
    }, []);

    useEffect(() => {
        getSerialNumberInfo(serialNumbers.map(v => v.serialNumber)).then((products) => {
            for (let i = 0; i < serialNumbers.length; i++) {
                serialNumbers[i].valid = true;
                delete serialNumbers[i].registered;
            }

            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                const serialNumberData = serialNumbers.find(v => v.serialNumber === product.serialNumber);

                if (serialNumberData) {
                    serialNumberData.valid = false;
                }
            }

            forceUpdate();
        });
    }, [serialNumbers]);

    return <div class="luna-emg-tablet-page">
        <Snackbar doShow={showSnackbar}/>
        <div class="paper serial-input">
            <ScanPackQR onRead={(data) => {
                const text = JSON.parse(data) as string;
                let match = elementLotRegexGs1.exec(text);

                if (!match || match.length < 2) {
                    return;
                }

                const serialNumber = match[1].trim();

                setSerialNumber(serialNumber);

                if (serialNumbers.find(v => serialNumber === v.serialNumber)) {
                    return;
                }

                setSerialNumbers([
                    ...serialNumbers,
                    {
                        lot: serialNumber,
                        serialNumber: "gtin-" + serialNumber,
                        valid: false
                    }
                ]);
            }}/>
            <div style="margin-top: 10px;">
                <label>
                    <span style="margin-right: 10px;">Podaj lub zeskanuj numer LOT pilota</span>
                    <input value={serialNumber} onChange={e => {
                        setSerialNumber(e.currentTarget.value.trim());
                        e.currentTarget.setCustomValidity(!e.currentTarget.value.match(elementLotRegex) ? "Nieprawidłowy numer seryjny" : "");
                    }} />
                </label>
            </div>
            {!productType || !productType.gtin ? <div style="margin-top: 10px;">
                <Alert type="error">Dodawanie partii pilotów nie jest możliwe ze względu na brak przypisanego numeru GTIN</Alert>
            </div> : null}
            <div style="margin-top: 10px;">
                <button class={productType && productType.gtin && isSerialNumberValid ? "" : "disabled"} onClick={() => {
                    if (serialNumbers.find(v => serialNumber === v.serialNumber)) {
                        return;
                    }

                    setSerialNumbers([
                        ...serialNumbers,
                        {
                            lot: serialNumber,
                            serialNumber: productType!.gtin + serialNumber,
                            valid: false
                        }
                    ]);
                }}>Dodaj Partie</button>
            </div>
            <div class="paper-2 serial-list">
                <h2 style="padding-bottom: 10px;">Numery partii LOT do rejestracji</h2>
                <table style="width: 100%; text-align: left;">
                    <thead>
                        <th>LOT</th>
                        <th>Numer seryjny partii</th>
                        <th>Walidacja</th>
                        <th>Usuń</th>
                    </thead>
                    <tbody>
                        {serialNumbers.map((v, i) => <tr class={(v.registered === true ? "register-success" : v.registered === false ? "register-fail" : "")}>
                            <td style="white-space: nowrap">{v.lot}</td>
                            <td style="width: 100%">{v.serialNumber}</td>
                            <td class="validation">{!v.valid ? <button class="icon r26 error tooltip-accent tooltip-bottom" data-tooltip="Tablet o podanym numerze seryjnym istnieje już w bazie danych">priority_high</button>
                                : <button class="icon r26 success tooltip-accent tooltip-bottom" data-tooltip="Numer seryjny jest poprawny">check</button>}
                            </td>
                            <td class="remove">
                                <button type="button" class="flat icon error tooltip-top" data-tooltip="Usuwa pozycje z listy" onClick={() => {
                                    serialNumbers.splice(i, 1);
                                    setSerialNumbers([...serialNumbers]);
                                }}>close</button>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <div style="margin-top: 10px">
                <button type="button" class={serialNumbers.length > 0 && serialNumbers.every(v => v.valid) ? "" : "disabled"} onClick={async () => {
                    const promises = [];

                    for(let i = 0; i < serialNumbers.length; i++) {
                        const serialNumberData = serialNumbers[i];

                        promises.push(addProductToDatabase("LE-EStop", serialNumberData.lot).then(() => {
                            serialNumberData.registered = true;
                            forceUpdate();
                        }).catch((ex) => {
                            serialNumberData.registered = false;
                            forceUpdate();
                            throw ex;
                        }));
                    }

                    try {
                        await Promise.all(promises);
                        showSnackbar.run("Wszystkie tablety zostały zarejestrowane pomyślnie", "success", "check");
                    }
                    catch(ex) {
                        showSnackbar.run("Nie udało się zarejestrować niektórych tabletów", "error", "check");
                    }
                }}>Zarejestruj</button>
            </div>
        </div>
        {/* <div class="paper" style="margin-top: 10x">
            <table>
                <tbody>
                    {existingEStopSerialNumbers.map(v => <tr>
                        <td>{v.serialNumber.split("-")[1]}</td>
                        <td>{v.serialNumber}</td>
                        <td>{v.creator}</td>
                        <td>{v.createdAt}</td>
                    </tr>)}
                </tbody>
            </table>
        </div> */}
    </div>;
}
